import { useState } from "react";

import styles from "../AccountsModule.module.scss";
import AccountListRow from "../AccountListRow";

import type { AccountClassType } from "./types";
import type { AddAccountMode } from "../../../../components/settings/linked_accounts/types";

type CollapsibleListGroupProps = {
  title: string;
  accounts: AccountClassType[];
  onVerify?: (account: AccountClassType) => void;
  onTriggerInstantVerification?: (mode: AddAccountMode) => void;
};

const CollapsibleListGroup = ({
  title,
  accounts,
  onVerify,
  onTriggerInstantVerification,
}: CollapsibleListGroupProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (accounts.length === 0) return null;

  return (
    <>
      <button
        type="button"
        className={`${styles.listGroupHeader} button--reset`}
        onClick={() => setIsExpanded((prev) => !prev)}
        aria-expanded={isExpanded}
      >
        <span className={styles.listGroupHeaderText}>{title}</span>
        <span
          className={
            isExpanded ? "narmi-icon-chevron-up" : "narmi-icon-chevron-down"
          }
        />
      </button>
      {isExpanded &&
        accounts.map((account) => (
          <AccountListRow
            key={account.id}
            account={account}
            isEditing
            isHidden
            onVerify={onVerify}
            onTriggerInstantVerification={onTriggerInstantVerification}
          />
        ))}
    </>
  );
};

export default CollapsibleListGroup;
